import React from 'react';
import classnames from 'classnames';
import Button from '../../../../components/Button';
import ButtonLink from '../../../../components/ButtonLink';

import { filterButton, active as activeStyle } from './styles.module.css';

export const FilterButton = ({
  active,
  text,
  link,
  children,
  className,
  ...props
}) => {
  if (link) {
    return (
      <ButtonLink
        primary={active}
        to={link}
        className={classnames(filterButton, {
          [activeStyle]: active,
          [className]: !!className,
        })}
        {...props}
      >
        {text ?? children}
      </ButtonLink>
    );
  }

  return (
    <Button
      primary={active}
      className={classnames(filterButton, {
        [activeStyle]: active,
        [className]: !!className,
      })}
      {...props}
    >
      {text ?? children}
    </Button>
  );
};
